import { render, staticRenderFns } from "./_produto.vue?vue&type=template&id=3e8fd281&"
import script from "./_produto.vue?vue&type=script&lang=js&"
export * from "./_produto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports